export default __webpack_public_path__ + "static/media/ios-s1_bk.b8a5e881.webp";